export const light = {
    //white - purple theme
    body:"#fff", //light
    text:"#2a2a3d", //dark
    bodyRgba : "42, 42, 61", //dark
    textRgba : "255, 255, 255", //light
    showcase: "#05011a",

    carouselColor : "#e7defa",

    fontxs: '0.75em',
    fontsm: '0.875em',
    fontmd: '1em', //1em = 16px
    fontlg: '1.25em',
    fontxl: '2em',
    fontxxl: '3em',
    fontxxxl: '4em',

    fontButton:'0.875em',

    navHeight:'5rem',

}

export const dark = {
    //purple - gray theme
    body:"#474766", //dark
    text:"#474766", //white
    bodyRgba : "193, 193, 245", //black shade
    textRgba : "42, 42, 61", //white

    carouselColor : "#e7defa",

    fontxs: '0.75em',
    fontsm: '0.875em',
    fontmd: '1em', //1em = 16px
    fontlg: '1.25em',
    fontxl: '2em',
    fontxxl: '3em',
    fontxxxl: '4em',

    fontButton:'0.875em',

    navHeight:'5rem',

}